<template>
  <v-card v-if="list_distribution_hostel_statements.length === 0" height="900px">
    <v-layout justify-center align-center fill-height>
      <v-progress-circular :size="120" :width="8" indeterminate color="teal"></v-progress-circular>
    </v-layout>
  </v-card>
  <v-card elevation="0" v-else>
    <v-card class="mt-4" outlined rounded="xl">
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <v-select
              v-model="status_place"
              :items="['Заполненные','Пустые', 'Частично заполненные']"
              label="Фильтр комнат"
              dense
              outlined
              clearable
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="search_student"
              label="Поиск студента"
              dense
              outlined
              hide-details
            >
              <template v-slot:append>
                <v-icon size="20px">
                  fa-search
                </v-icon>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-row class="mt-2">
        <v-col
          class="d-flex"
          v-for="(place, index_distr) in distribution_places_list"
          :key="index_distr"
          cols="12"
          md="4"
          lg="3"
        >
          <v-card max-height="500px" rounded="xl" outlined width="100%">
            <v-card-title class="text-center">
              <v-row>
                <v-col cols="12">
                  <h6 class="text-subtitle-1">
                    {{ place.name_hostel + " | " + place.name_room}}
                  </h6>
                  <h6 class="text--secondary text-subtitle-1 text-center">
                    Всего мест: {{place.room_info.total}}
                  </h6>
                </v-col>
                <v-col cols="12">
                  <v-chip
                    class="mx-auto"
                    outlined
                    :color="setColor(place).color"
                  >
                    <div>
                      {{ setColor(place).text }}
                    </div>
                  </v-chip>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text class="text-center">
              <v-list-item
                v-for="(student, index_student) in listStatement(place)" :key="index_student"
                link
                dense
                class="px-0"
              >
                <v-list-item-title class="pr-2 text-subtitle-1">{{ student.full_name }}</v-list-item-title>
                <v-list-item-avatar class="ma-0">
                  <v-icon small :color="student.color">
                    {{ student.icon }}
                  </v-icon>
                </v-list-item-avatar>
              </v-list-item>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
  </v-card>
</template>

<script>
    import {mapActions, mapMutations, mapState, mapGetters} from "vuex";
    import _ from "lodash";
    import store from "../../../../../stores/application/index.js.erb";

    export default {
        name: "ListConfStatements",
        data: () => ({
            status_place: '',
            search_student: ''
        }),
        mounted() {
            this.GetListDistributionHostelStatements();
        },
        watch: {},
        computed: {
            ...mapState({
                list_distribution_hostel_statements: state => state.interactionStatement.list_distribution_hostel_statements,
                distribution_places: state => state.placesInDormitories.distribution_places,
                list_statements: state => state.interactionStatement.list_statements,
                hostel_orders: state => state.interactionStatement.hostel_orders,
                status_cr_order: state => state.interactionStatement.status_cr_order,
                stm_applicants: state => state.interactionStatement.stm_applicants,
            }),
            ...mapGetters({
            }),
            distribution_places_list() {
                let list_places = []

                this.distribution_places.places.forEach((hostel) => {
                    hostel.sections.forEach((section) => {
                        section.rooms.forEach((room) => {
                            list_places.push(
                                {
                                    name_hostel: hostel.name_hostel,
                                    name_section: section.name_section,
                                    name_room: room.name_room,
                                    room_info: room.room_info,
                                }
                            )
                        })
                    })
                })

                if (this.search_student){

                    let search_filter = this.list_distribution_hostel_statements.filter((statement) => {
                        if (statement.person.full_name.includes(this.search_student)){
                            return statement
                        }
                    })

                    let filter_places = []

                    search_filter.forEach((student) => {
                        list_places.forEach((place) => {
                            if (place.name_hostel === student.statement_hostel.result_place.name_hostel &&
                                place.name_section === student.statement_hostel.result_place.name_section &&
                                place.name_room === student.statement_hostel.result_place.name_room){

                                filter_places.push(place)
                            }
                        })
                    })

                    return filter_places
                }

                return list_places
            },
            show_status_order() {
                if (Object.keys(this.status_cr_order)[0] === 'Result') return 'green'
                return 'red'
            },
        },
        methods: {
            ...mapMutations({
                setTreeStatements: 'interactionStatement/setTreeStatements',
            }),
            ...mapActions({
                CreateOrder: 'interactionStatement/CreateOrder',
                IndexOrder: 'interactionStatement/IndexOrder',
                GetListDistributionHostelStatements: 'interactionStatement/GetListDistributionHostelStatements',
            }),
            listStatement(place) {
                let control_group = []

                //let res_statements = _.unionBy(this.list_statements, this.stm_applicants.stm_hostel_all, 'full_name')

                this.list_distribution_hostel_statements.forEach(statement => {
                    if (statement.statement_hostel.result_place?.name_hostel === place.name_hostel &&
                        statement.statement_hostel.result_place?.name_section === place.name_section &&
                        statement.statement_hostel.result_place?.name_room === place.name_room) {
                        control_group.push(
                            {
                                full_name: statement.person.full_name,
                                hostel_order_check: statement.statement_hostel.hostel_order_check,
                                color: statement.statement_hostel.hostel_order_check ? 'green' : 'orange',
                                icon: statement.statement_hostel.hostel_order_check ? 'fa-check-circle' : 'fa-exclamation-circle'
                            }
                        )
                    }
                })

                return control_group
            },
            setColor(place) {
                if (place.room_info.occupied === place.room_info.total) return {
                    color: 'green',
                    text: 'Заполнена'
                }
                if (place.room_info.occupied !== 0) return {color: 'orange', text: 'Частично заполненная'}

                return {color: 'grey', text: 'Пустая'}
            },
            filterList(place) {
                if (this.status_place === 'Заполненные') {
                    if (this.setColor(place) === 'green') return true
                } else if (this.status_place === 'Пустые') {
                    if (this.setColor(place) === 'grey') return true
                } else if (this.status_place === 'Частично заполненные') {
                    if (this.setColor(place) === 'orange') return true
                } else if (!this.status_place) return true
            },
            createOrder() {
                this.error_states = _.filter(this.tree_statements.arr_states, function (item) {
                    return (item.statement.YSB_confirm !== 2 ||
                        item.statement.accountant_confirm !== 2 ||
                        item.statement.campus_confirm !== 2 ||
                        item.statement.commandant_confirm !== 2)
                })
                if (this.error_states.length !== 0) {
                    this.show_error = true
                } else {
                    this.CreateOrder().then(() => {
                        this.snackbar = true
                        this.step = 1
                    })
                }
            }
        },
    }

</script>

<style scoped>

</style>